module.exports = __webpack_public_path__ + "img/snorkeling-2.98e6a71a.jpeg";